import VueRouter from 'vue-router'
import Vue from 'vue';
import nprogress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store/index.js';
import { Message } from 'element-ui';
import { get_token } from '@/utils/token.js';

Vue.use(VueRouter)
const oldPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (loaction, onComplate = () => { }, onAbort = () => { }) {
    oldPush.call(this, loaction, onComplate, onAbort)
}
const oldReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function (loaction, onComplate = () => { }, onAbort = () => { }) {
    oldReplace.call(this, loaction, onComplate, onAbort)
}
import routes from './routes.js'
const router = new VueRouter({
    mode: 'history',
    routes // (缩写) 相当于 routes: routes
})



router.beforeEach(async (to, from, next) => {
    nprogress.start()
    //路由鉴权 判断有没有token 
    const token = get_token()
    if (token) {
        //判断要去的地方是不是登录页
        if (to.name === 'Login') {
            if (to.params.timeOut == 0) {
                next()
            } else {
                next('/')
            }
        } else {
            // 有token 还要判断是否有用户信息 
            const userInfo = store.state.userName
            if (userInfo) {
                //有用户信息 说明刚请求完成 token 没问题
                next()
            } else {
                //没有用户信息 不确定token 是否有问题 发送请求校验token 
                try {
                    await store.dispatch('get_userInfo')
                    //请求成功 说明没问题 放行
                    next()
                } catch (err) {
                    //请求失败 说明token 有问题 导航至登录页 并删除当前有问题的token 
                    store.commit('delete_user')
                    Message.error('Login expired, please login again!!!')
                    to.meta.isJudge ? next('/login') : next()
                }
            }
        }
    } else {
        //没有token  判断要去的地方需不需要鉴权
        if (to.meta.isJudge) {
            //需要鉴权 就导航至登录页
            next('/login')
        } else {
            //不需要直接放行 
            next()
        }

    }
})

// 全局后置钩子
router.afterEach(() => {
    nprogress.done()
})

export default router